import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  modalBackdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  card: {
    overflow: 'auto',
    borderRadius: 16,
    boxShadow: '0 20px 45px rgba(0, 0, 0, 0.2)',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.1rem',
    flex: 1,
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontSize: '25px',
    fontFamily: 'Montserrat',
  },
  closeButton: {
    padding: '4px',
    color: theme.palette.text.primary,
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  mainSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '30px',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
    },
  },
  imageContainer: {
    borderRadius: 8,
    width: '100%',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: theme.palette.grey[100],
    minHeight: '400px',
  },
  imageLoading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    maxHeight: 600,
  },
  noImageMessage: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '16px',
    fontFamily: 'Montserrat',
  },
  pdfContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
  pdfFrame: {
    width: '100%',
    minHeight: '500px',
    border: 'none',
    borderRadius: '4px',
  },
  pdfOpenButton: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '13px',
    borderRadius: '8px',
  },
  buttonsContainer: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 'clamp(12px, 1.04vw, 21px)',
    padding: '10px 24px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  validateButton: {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 'clamp(12px, 1.04vw, 21px)',
    padding: '10px 24px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
}));

export default useStyles;
